module.exports = __webpack_public_path__ + "img/logo.afcb4a0f.png";